<template>
    <div>
        <public-title showBack>设置门店</public-title>
        <div class="bg-white load-area">
            <header class="pl-4 font-weight-bold text-muted">设置负责人</header>
            <div class="p-3 mt-2">
                <div class="d-flex flex-wrap mb-2">
                    <left-text leftText="负责人"/><span>{{BasicInfo.truename}} / {{BasicInfo.mobile}}</span>
                </div>
                <div class="d-flex flex-wrap mb-2">
                    <left-text leftText="所属集团"/><span>{{BasicInfo.group_name}}</span>
                </div>
                <div class="d-flex flex-wrap mb-2">
                    <left-text leftText="当前职位"/><span>{{BasicInfo.position_name}}</span>
                </div>
                <div class="d-flex flex-wrap">
                    <left-text leftText="负责门店"/><span>{{List.length}}家</span>
                </div>
                <div class="d-center-start">
                    <left-text leftText="解除关联门店"/>
                    <div class="text-left">
                        <el-tag class="mr-2 mt-3" v-for="tag in List" :key="tag.id" closable @close="setStores(tag,'remove')">
                            {{tag.title}}
                        </el-tag>
                    </div>
                </div>
                <div class="d-center-start" v-if="DetailCheckList.length > 0">
                    <left-text leftText="新增门店"/>
                    <div class="text-left">
                        <el-tag class="mr-2 mt-3" v-for="tag in DetailCheckList" :key="tag.id" @close="handleClose(tag)">
                            {{tag.title}}
                        </el-tag>
                    </div>
                </div>
                <div class="text-right">
                    <el-input placeholder="子门店名称" class="w-30 mt-4" size="small" v-model="nameCondition" @keyup.enter.native="getList">
                        <el-button slot="append" icon="el-icon-search" @click="getList">搜索</el-button>
                    </el-input>
                </div>
                <el-row class="border-top mt-4">
                    <el-col :span="12" v-for="(item,index) in allList" :key="index" class="text-left border-bottom p-2">
                        <el-checkbox-group :value="item" v-model="checkList">
                            <el-checkbox :label="item.id" :disabled="item.disabled">
                                {{item.title}}
                                <span class="text-gtext ml-3">{{item.province_name}}-{{item.city_name}}-{{item.district_name}}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-pagination background layout="prev, pager, next" class="mt-4" :total="total" :current-page=page
                    :page-size="14" @current-change="v => {this.page=v;this.getList()}"/>
                <div class="d-center-space m-5">
                    <el-button class="mr-5" type="primary" size="small" @click="setStores(0,'add')">添加门店</el-button>
                    <el-button size="small" @click="checkList=[]">重置</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations,mapActions} from 'vuex'

export default {
    name: 'removeLeader',
    data () {
        return {
            nameCondition: '',
            BasicInfo: {},
            List: [],
            allList: [],
            checkList: [],
            totalList: [],
            DetailCheckList: [],
            total: 0,                         // 分页器记录总条数
            page: 1
        }
    },
    computed: {
        queryCon() {
            return this.$route.query
        },
    },
    watch: {
       checkList (newVal) {
            this.DetailCheckList = this.totalList.filter(item => newVal.includes(item.id))
       }
    },
    created () {
        this.getStores()
    },
    methods: {
        ...mapMutations(['UPDATECURRENTSTORE']),
        ...mapActions(['getAdminDataLists']),
        //获取该负责人旗下门店
        async getStores() {
            let res = await this.$axios.post('/pc/Admin/GroupDetail',{
                group_id:this.queryCon.id,
            });
            if (res.code === '00000') {
                this.checkList = []
                this.BasicInfo = res.data.info
                this.List = res.data.store_list
                this.getList(res.data)
            }
        },
        getList (res) {
            this.allList = res.store_list;
            this.total = res.store_count;
            let oldids = this.List.map(v => v.id)
            this.allList.forEach(i => {
                if (oldids.includes(i.id)) this.$set(i,'disabled',true)
            })
            if (this.totalList.length > 0) {
                let sameid = this.totalList.map(v => v.id)
                let difarr = this.allList.filter(item => !sameid.includes(item.id))
                this.totalList = this.totalList.concat(difarr)
            } else {
                this.totalList = this.totalList.concat(this.allList)
            }
        },
        //移除
        handleClose(tag) {
            this.checkList.splice(this.checkList.indexOf(tag), 1);
        },
        async setStores(tag,type) {
            if (this.List.length == 1 && type == 'remove') {this.$message.warning('请先添加负责人再解除关联');return}
            if (this.DetailCheckList.length == 0 && type == 'add') {this.$message.warning('请至少添加一个门店');return}
            let store_data;
            let msg = `确定将该门店从${this.BasicInfo.truename}名下移除吗？`
            if (type == 'add') {
                let addstore = this.DetailCheckList.map(v => v.title).join('，')
                let allids = this.DetailCheckList.concat(this.List)
                let ids = allids.map(v => ({store_id: v.id, province: v.province, city: v.city, district:v.district}))
                store_data = ids
                msg = `确定为${this.BasicInfo.truename}添加${addstore}吗？`
            }
            this._confirm(msg,async () => {
                if (type == 'remove') {
                    let arr = this.List;
                    arr.splice(arr.findIndex(item => item.id == tag.id), 1)
                    store_data = arr.map(v => ({store_id: v.id, province: v.province, city: v.city, district:v.district}));
                }
                let res = await this.$axios.post('/pc/Admin/GroupRemoveStore',{
                    user_id: this.queryCon.id,
                    user_type: this.queryCon.type,
                    store_data
                });
                if (res.code === '00000') {
                    this.getStores(this.queryCon.id)
                    this.getList()
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
header{
    height: 40px;
    line-height: 40px;
    text-align: left;
    background-color: #fcfcfc
}
</style>